var map = {
	"./collection.de-CH.json": 1670,
	"./collection.de-DE.json": 1671,
	"./collection.en-CA.json": 1672,
	"./collection.en-GB.json": 1673,
	"./collection.en-IN.json": 1674,
	"./collection.en-ME.json": 1675,
	"./collection.en-US.json": 1676,
	"./collection.es-EM.json": 1677,
	"./collection.es-ES.json": 1678,
	"./collection.fr-BE.json": 1679,
	"./collection.fr-CA.json": 1680,
	"./collection.fr-CH.json": 1681,
	"./collection.nl-BE.json": 1682,
	"./collection.nl-NL.json": 1683,
	"./collection.pl-PL.json": 1684,
	"./collection.pt-BR.json": 1685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1669;